import { useContext } from 'react';

import { JournalEventsFiltersContext } from '@features/JournalEventsFilters/providers/context';

export const useJournalEventsFiltersContext = () => {
    const context = useContext(JournalEventsFiltersContext);
    if (!context) {
        throw new Error(
            'useJournalEventsFiltersContext must be used within a JournalEventsFiltersContextProvider'
        );
    }
    return context;
};
